import React, { useState, useEffect, useRef } from "react";
import { Select } from "antd";
// import { PlusOutlined } from "@ant-design/icons";
import { TError, TOption } from "../../types/common";

type SelectInputType = {
  onChange?(value: number | string, option: TOption | TOption[]): void;
  label?: string;
  value: number | string | null;
  name: string;
  options: TOption[];
  error?: TError;
  multiple?: "multiple" | "tags";
  disabled?: boolean;
  required?: boolean;
  loading?: boolean;
  acceptNewItems?: boolean;
  setNotFoundOption?: (value: boolean) => void;
  placeholder?: string | React.ReactNode;
  onFilterSearch?: (value: string) => void;
};

const SelectInput = (props: SelectInputType) => {
  const {
    onChange,
    value,
    options,
    multiple,
    disabled,
    loading = false,
    acceptNewItems = false,
    placeholder = "",
    setNotFoundOption = () => {},
    onFilterSearch,
    ...rest
  } = props;

  // const [newItemName, setNewItemName] = useState("");
  const [dynamicOptions, setDynamicOptions] = useState<TOption[]>(options);
  const debounceTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleSearch = (newValue: string) => {
    if (acceptNewItems) {
      const isSearchValueInState = options.some(
        (option) => option.value === newValue,
      );
      if (!isSearchValueInState || newValue === "") {
        setNotFoundOption(true);
      } else {
        setNotFoundOption(false);
      }
    }

    if (onFilterSearch) {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
      debounceTimerRef.current = setTimeout(() => {
        onFilterSearch(newValue);
      }, 500);
    }
  };

  // const addNewItem = () => {
  //   if (newItemName && newItemName.trim()) {
  //     const newOption = {
  //       value: newItemName,
  //       label: newItemName,
  //     };

  //     // Check if item already exists
  //     const exists = dynamicOptions.some(
  //       (option) =>
  //         option.value === newItemName || option.label === newItemName,
  //     );

  //     if (!exists) {
  //       const updatedOptions = [...dynamicOptions, newOption];
  //       setDynamicOptions(updatedOptions);

  //       // Auto-select the new item
  //       if (onChange) {
  //         onChange(newItemName, newOption);
  //       }
  //     } else {
  //       // If exists, just select it
  //       if (onChange) {
  //         const existingOption = dynamicOptions.find(
  //           (option) =>
  //             option.value === newItemName || option.label === newItemName,
  //         );
  //         if (existingOption && typeof existingOption.value !== "boolean") {
  //           onChange(existingOption.value, existingOption);
  //         }
  //       }
  //     }

  //     setNewItemName("");
  //     setTimeout(() => {
  //       inputRef.current?.focus();
  //     }, 0);
  //   }
  // };

  // const handleKeyPress = (e: React.KeyboardEvent) => {
  //   if (e.key === "Enter") {
  //     e.preventDefault();
  //     addNewItem();
  //   }
  // };

  // Update dynamic options when props.options change
  useEffect(() => {
    setDynamicOptions(options);
  }, [options]);

  // For multiple selections with new items, use tags mode
  if (multiple === "multiple" && acceptNewItems) {
    return (
      <div>
        <Select
          mode="tags"
          showSearch
          allowClear
          optionFilterProp="children"
          onChange={onChange}
          value={value}
          style={{
            display: "block",
            width: "100%",
            minHeight: 36,
            fontWeight: 500,
          }}
          options={dynamicOptions}
          disabled={disabled}
          size="middle"
          loading={loading}
          getPopupContainer={(node) => node.parentNode}
          placeholder={placeholder}
          onSearch={handleSearch}
          {...rest}
        />
      </div>
    );
  }

  // For single selection with new items, use dropdownRender
  return (
    <div>
      <Select
        showSearch
        allowClear
        optionFilterProp="children"
        onChange={onChange}
        value={value as number | string}
        filterOption={
          onFilterSearch
            ? false
            : (input, option) =>
                String(option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
        }
        style={{
          display: "block",
          width: "100%",
          height: 36,
          fontWeight: 500,
        }}
        options={dynamicOptions}
        mode={multiple && "multiple"}
        disabled={disabled}
        size="middle"
        loading={loading}
        getPopupContainer={(node) => node.parentNode}
        placeholder={placeholder}
        onSearch={handleSearch}
        dropdownRender={
          acceptNewItems && !disabled
            ? (menu) => (
                <>
                  {menu}
                  {/* <Divider style={{ margin: "8px 0" }} />
                  <div
                    style={{
                      padding: "0 8px 4px",
                      display: "flex",
                      gap: "4px",
                    }}
                  >
                    <Input
                      placeholder="Enter new item"
                      ref={inputRef}
                      value={newItemName}
                      onChange={(e) => setNewItemName(e.target.value)}
                      onKeyDown={handleKeyPress}
                      style={{ flex: 1 }}
                      size="small"
                    />
                    <Button
                      type="text"
                      icon={<PlusOutlined />}
                      onClick={addNewItem}
                      size="small"
                      style={{ flexShrink: 0 }}
                    >
                      Add
                    </Button>
                  </div> */}
                </>
              )
            : undefined
        }
        {...rest}
      />
    </div>
  );
};

export default SelectInput;
